<div class="modal-container-custom">
  <div class="modal-content-custom selectStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">Select Authorised Signatories</h4>
    </div>
    <div class="modal-body">
      <div *ngFor="let document of modalInputs.documentsToDisplay; last as isLast">
        <h6 class="text-center margin-15 enabled-text cp-underline">{{document?.docName}}</h6>
        <div class="margin-15">
          <app-icici-select-input id="select-signatory-input" [dropdownListType]="'staticItemsList'"
            [dropDownItemsList]="signatoriesListModel[document.docKey]"
            [notFoundText]="'Could not find the specified signatory.'" [placeholder]="'Search for Signatories ... '"
            [selectedItems]="(existingSelectedSignatories && existingSelectedSignatories[document.docKey]) || []"
            [selectedItemsIdField]="'id'" (itemSelectedEvent)="onSignatoryListChange($event, document.docKey)">
          </app-icici-select-input>
        </div>
      </div>
    </div>
    <div class="modal-footer modal-footer-custom">
      <button type="button" class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        (click)="activeModal.close()">Cancel</button>
      <button id="send-selected-signatory" [disabled]="!allSignatoriesSelected ? true : null"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        (click)='sendSignatories()'>Send</button>
    </div>
  </div>
</div>
